
import { mapState, mapActions } from 'vuex'

export default {
  name: 'BreadCrumb',

  props: {
    defaultCrumbs: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      crumbs: [],
    }
  },

  computed: {
    ...mapState('menu', ['menu']),
  },

  async created() {
    if (!this.menu) await this.getMenu()
    this.buildBreadcrumbs(this.menu)
  },

  methods: {
    ...mapActions('menu', ['getMenu']),

    buildBreadcrumbs(menuItems) {
      if (this.defaultCrumbs.length) {
        this.crumbs = this.defaultCrumbs
        return
      }

      menuItems.forEach((item) => {
        if (this.$route.fullPath.includes(item.page.furl))
          this.crumbs.push({
            label: item.page.menu_title,
            to: `/${item.page.furl}`,
          })

        if (this.$route.fullPath !== `/${item.page.furl}` && item.children) {
          this.buildBreadcrumbs(item.children)
        }
      })
    },
  },
}
